import { render } from "./LogoPuntaNegraCompleto.vue?vue&type=template&id=fbd85dd4"
import script from "./LogoPuntaNegraCompleto.vue?vue&type=script&lang=js"
export * from "./LogoPuntaNegraCompleto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__